
import React from "react";
import { calculateBookingPayment } from "../utils/bookingPricing";


const PAYMENT_METHODS = [
  {
    value: "cashapp",
    label: "Cash App",
    logo: "/images/cash-app.png",
  },
  {
    value: "zelle",
    label: "Zelle",
    logo: "/images/zelle.png",
  },
];

function DepositPayment({
  totalPrice,
  paymentMethod,
  onPaymentMethodChange,
}) {
  const payment = calculateBookingPayment(totalPrice);

  const money = (amount) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);

  return (
    <section className="deposit-payment">
      <p className="deposit-eyebrow">SECURE YOUR APPOINTMENT</p>
      <h2>Booking Deposit</h2>
      <p className="deposit-description">
        A 20% deposit is required to book your appointment.
        The remaining balance is due according to your booking policy.
      </p>

      <div className="deposit-breakdown">
        <div>
          <span>Total appointment price</span>
          <strong>{money(payment.total)}</strong>
        </div>

        <div className="deposit-required">
          <span>Deposit required (20%)</span>
          <strong>{money(payment.deposit)}</strong>
        </div>

        <div>
          <span>Remaining balance (80%)</span>
          <strong>{money(payment.balance)}</strong>
        </div>
      </div>


        <fieldset className="payment-method-fieldset">
        <legend>Choose your payment method</legend>

        <div className="payment-method-options">
            {PAYMENT_METHODS.map((method) => (
            <label
                className={`payment-method-option ${
                paymentMethod === method.value ? "selected" : ""
                }`}
                key={method.value}
            >
                <input
                type="radio"
                name="paymentMethod"
                value={method.value}
                checked={paymentMethod === method.value}
                onChange={() => onPaymentMethodChange(method.value)}
                required
                />

                <img
                className={`payment-method-logo ${method.value}`}
                src={method.logo}
                alt=""
                aria-hidden="true"
                />

                <span>{method.label}</span>
            </label>
            ))}
        </div>
        </fieldset>

      {paymentMethod && (
        <div className="payment-instructions">
          <h3>
            Pay your {money(payment.deposit)} deposit using{" "}
            {PAYMENT_METHODS.find(
              (method) => method.value === paymentMethod
            )?.label}
          </h3>

          {paymentMethod === "cashapp" ? (
            <p>
              Placeholder: Add your verified Cash App $Cashtag or
              payment link here.
            </p>
          ) : (
            <p>
              Placeholder: Add the Zelle recipient name and the
              verified phone number or email address here.
            </p>
          )}

          <p>
            Your appointment is not confirmed until the deposit
            has been received and verified.
          </p>
        </div>
      )}
    </section>
  );
}

export default DepositPayment;